import { buildPayloadApiUrl, payloadFetch } from "./client";
import { mapEgdCarouselResponse } from "src/utils/mapEgdCarousel";

/**
 * Fetches EGD page carousel slides from pg-payload-cms (`egd-carousel`).
 * Filtering by publish/unpublish dates is done client-side via shouldPublish().
 * Enabled when `carousels` is listed in `REACT_APP_PAYLOAD_SOURCES`
 * (same flag as home + poker carousels).
 *
 * @param {string} locale - `en` | `fr`
 * @returns {Promise<import('src/utils/mapEgdCarousel').EgdCarouselSlide[]>}
 */
export async function fetchEgdCarousel(locale) {
  const url = buildPayloadApiUrl("/api/egd-carousel", {
    locale,
    limit: 50,
    sort: "_order",
    depth: 0,
  });

  const response = await payloadFetch(url);
  return mapEgdCarouselResponse(response, locale);
}
